import { createReducer } from 'reduxsauce';
import { cloneDeep, isEqual, filter, findIndex } from 'lodash';
import { COMPANY_WIDE_BRANCH } from '@rapid-recovery-agency-inc/insightt-shared';

import { ENVIRONMENT } from '../../constants/env-constants';
import { AppTypes } from '../actions/app.actions';

const initialState = {
  status: [],
  version: ENVIRONMENT.PACKAGE_VERSION,
  mobileMenuShow: false,
  notificationBarShow: false,
  collapseMenu: false,
  branchesCompany: [],
  branches: [],
  branchOptions: [],
  branchSelections: [],
  roles: [],
  roleOptions: [],
  alerts: [],
  serverTime: null,
};

const clickOnMobileMenu = (state) => {
  const { mobileMenuShow } = state;
  return { ...state, mobileMenuShow: !mobileMenuShow };
};

const clickCollapseMenu = (state, action) => ({
  ...state,
  collapseMenu: !!action.status,
});

const getBranchesRequest = (state) => ({ ...state });
const getBranchesSuccess = (state, action) => {
  const { response } = action;
  const branchesCompany = response.map((branch) => ({
    id: branch.id,
    name: branch.name,
  }));
  const branches = [...branchesCompany];
  branches.unshift(COMPANY_WIDE_BRANCH);
  branches.push({
    id: -1,
    name: 'Unknown',
  });

  const branchOptions = response.map((branch) => ({
    value: branch.id,
    label: branch.name,
  }));

  const branchSelections = [
    {
      value: COMPANY_WIDE_BRANCH.id,
      label: COMPANY_WIDE_BRANCH.name,
    },
    ...branchOptions,
  ];

  return {
    ...state,
    branchesCompany,
    branches,
    branchOptions,
    branchSelections,
  };
};
const getBranchesFailure = (state) => ({ ...state });

const getRolesRequest = (state) => ({ ...state });
const getRolesSuccess = (state, action) => {
  const roles = action.response;

  const roleOptions = roles.map((role) => ({
    value: role.id,
    label: role.name,
  }));

  return { ...state, roles, roleOptions };
};
const getRolesFailure = (state) => ({ ...state });

const getAlertsRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-get-alerts');

  return { ...state, status };
};
const getAlertsSuccess = (state, action) => {
  const alerts = action.response;

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-alerts', a));

  return { ...state, alerts, status };
};
const getAlertsFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-alerts', a));

  return { ...state, status };
};

const toggleAlertRequest = (state, action) => {
  const { payload } = action;

  const status = cloneDeep(state.status);
  status.push(`pending-toggle-alert-${payload.method}`);

  return { ...state, status };
};
const toggleAlertSuccess = (state, action) => {
  const alerts = cloneDeep(state.alerts);
  const idx = findIndex(alerts, () => isEqual(alert.id, action.response.id));
  if (idx > -1) {
    alerts[idx] = action.response;
  } else {
    alerts.unshift(action.response);
  }

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-toggle-alert-${action.response.method}`, a));

  return { ...state, alerts, status };
};
const toggleAlertFailure = (state, action) => {
  const { payload } = action;

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual(`pending-toggle-alert-${payload.method}`, a));

  return { ...state, status };
};

const getServerTimeRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-get-server-time');

  return { ...state, status };
};
const getServerTimeSuccess = (state, action) => {
  const serverTime = action.response;

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-server-time', a));

  return { ...state, serverTime, status };
};
const getServerTimeFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-get-server-time', a));

  return { ...state, status };
};

const setServerTimeRequest = (state) => {
  const status = cloneDeep(state.status);
  status.push('pending-set-server-time');

  return { ...state, status };
};
const setServerTimeSuccess = (state, action) => {
  const serverTime = action.response;

  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-set-server-time', a));

  return { ...state, serverTime, status };
};
const setServerTimeFailure = (state) => {
  let status = cloneDeep(state.status);
  status = filter(status, (a) => !isEqual('pending-set-server-time', a));

  return { ...state, status };
};

const clearAppRequest = (state) => ({ ...state, ...initialState });

export const reducer = createReducer(initialState, {
  [AppTypes.CLICK_ON_MOBILE_MENU]: clickOnMobileMenu,
  [AppTypes.CLICK_COLLAPSE_MENU]: clickCollapseMenu,

  [AppTypes.GET_BRANCHES_REQUEST]: getBranchesRequest,
  [AppTypes.GET_BRANCHES_SUCCESS]: getBranchesSuccess,
  [AppTypes.GET_BRANCHES_FAILURE]: getBranchesFailure,

  [AppTypes.GET_ROLES_REQUEST]: getRolesRequest,
  [AppTypes.GET_ROLES_SUCCESS]: getRolesSuccess,
  [AppTypes.GET_ROLES_FAILURE]: getRolesFailure,

  [AppTypes.GET_ALERTS_REQUEST]: getAlertsRequest,
  [AppTypes.GET_ALERTS_SUCCESS]: getAlertsSuccess,
  [AppTypes.GET_ALERTS_FAILURE]: getAlertsFailure,

  [AppTypes.TOGGLE_ALERT_REQUEST]: toggleAlertRequest,
  [AppTypes.TOGGLE_ALERT_SUCCESS]: toggleAlertSuccess,
  [AppTypes.TOGGLE_ALERT_FAILURE]: toggleAlertFailure,

  [AppTypes.GET_SERVER_TIME_REQUEST]: getServerTimeRequest,
  [AppTypes.GET_SERVER_TIME_SUCCESS]: getServerTimeSuccess,
  [AppTypes.GET_SERVER_TIME_FAILURE]: getServerTimeFailure,

  [AppTypes.SET_SERVER_TIME_REQUEST]: setServerTimeRequest,
  [AppTypes.SET_SERVER_TIME_SUCCESS]: setServerTimeSuccess,
  [AppTypes.SET_SERVER_TIME_FAILURE]: setServerTimeFailure,

  [AppTypes.CLEAR_APP_REQUEST]: clearAppRequest,
});
